import FeaturePhotographerPick from './FeaturePhotographerPick.vue'
import FeatureCollaboratorLimits from './FeatureCollaboratorLimits.vue'
import FeaturePriceLockAfterSale from './FeaturePriceLockAfterSale.vue'
import FeaturePhotoEditor from './FeaturePhotoEditor.vue'

/**
 * Map feature keys to their Vue components.
 * Each feature has its own dedicated component for full UI control.
 */
export const FEATURE_COMPONENTS = {
    photographer_pick: FeaturePhotographerPick,
    collaborator_limits: FeatureCollaboratorLimits,
    price_lock_after_sale: FeaturePriceLockAfterSale,
    photo_editor: FeaturePhotoEditor,
}

export default FEATURE_COMPONENTS
